import { render, staticRenderFns } from "./StudyConversationMessageBodyText.vue?vue&type=template&id=3c1cb77e&scoped=true"
import script from "./StudyConversationMessageBodyText.vue?vue&type=script&lang=js"
export * from "./StudyConversationMessageBodyText.vue?vue&type=script&lang=js"
import style0 from "./StudyConversationMessageBodyText.vue?vue&type=style&index=0&id=3c1cb77e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1cb77e",
  null
  
)

export default component.exports